import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './TopologySidebar.scss';
import {
	InputAdornment,
	InputBase,
	Box,
	Button,
	IconButton,
	Grid,
} from '@mui/material';
import { ColouredAdd, SearchIconColored, GreySearch } from '../../../assets/icons/index.js';
// import { PinIcon } from '../../../assets/icons/index.js';
// import { GroupSideBarCollapseIcon } from '../../../assets/icons/index.js';

import {
	listGroup,
	listGroupBySite,
	listGroupChildBySite,
	searchGroupBySite,
} from '../../../actions/groupActions';
import { useEffect } from 'react';
import {
	GROUP_BY_SITE_COPY,
	GROUP_REQUEST_BY_SITE_GET,
	GROUP_RESPONSE_BY_SITE_GET_SUCCESS,
	INITIAL_SITE_ID,
	OPEN_CLOSE_ADD_GROUP_MODAL,
	SET_TOPOLOGY_EXPANDED_VIEW,
	SET_TOPOLOGY_SEARCH_VALUE,
} from '../../../constants/groupConstants';
import {
	// SIDE_BAR_TOPOLOGY_FLOATING,
	SELECTED_NODE_TOPOLOGY,
} from '../../../constants/topologyConstants';
import {
	UPDATE_BREADCRUMBS_STATE,
	BREADCRUMBS_URL,
} from '../../../constants/breadcrumbsConstant';
import useTheme from '../../../hooks/useTheme';
import Loader from '../../../components/loader/Loader';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
// import { IS_SIDE_BAR_TOPOLOGY_OPEN } from '../../../constants/topologyConstants';
// import Tooltip from '../../../components/tooltip/Tooltip';
import {
	getSpecificString,
	replacePipeWithAnd,
} from '../../../utils/breadCrumbUtils.js';
import { ClearOutlined } from '@mui/icons-material';
import { useRef } from 'react';
import TopologyLazyTree from '../topology-lazy-tree/index.jsx';
import {SITE_PERMISSION,ADD_PERMISSION} from '../../../constants/permissionConstants.js';
import {fetchPermission} from '../../../utils/utility';
import { useState } from 'react';
import CustomCheckbox from '../../../components/checkbox/Checkbox.jsx';
import Label from '../../../components/label/Label.jsx';
/**
 * Renders a topology sidebar component( which displays all the groups in the topology)
 * @return {JSX.Element} The JSX element representing the topology sidebar.
 */
export default function TopologySidebar({
	triggerSidebarRefresh,
	setIsHovered,
	onTopologySelected,
	sidebarWidth = 260,	
}) {
	const { color, FontFace } = useTheme('LIGHT');
	const canAddSite = fetchPermission(SITE_PERMISSION, ADD_PERMISSION);
	const dispatch = useDispatch();
	const { group } = useSelector((state) => state.groupList);
	const groupListBySiteState = useSelector(
		(state) => state.groupListBySiteReducer
	);
	const inputRef = useRef(null);
	const topology = useSelector((state) => state.topology);
	const { selectedNode } = topology;
	// const triggerTourGuideModal = useSelector(
	// 	(state) => state.tourGuide.triggerTourGuideModal
	// );
	const [isFocused, setIsFocused] = React.useState(false);
	const tourStep = useSelector((state) => state.tourGuideStep.tourStep);
	const { apiLoading: groupDashStatsApiloading } =
		useSelector((state) => state.groupDashboardStatsReducer);
	// const { group, loading } = groupList;
	const { groupListBySite,groupBySiteCopy,loading: loadingBySite, childData } = groupListBySiteState;
	const searchValue = useSelector(state => state.sidebarSearchReducer.topologySearchValue);
	const isExpandedView = useSelector(state => state.sidebarSearchReducer.isExpandedView);
	const setSearchValue = (val) => {
		dispatch({ type: SET_TOPOLOGY_SEARCH_VALUE, payload: val });
	}; 
	const didMountRef = useRef(false);

	// const [treeData, setTreeData] = React.useState([]);
	// const [initialData, setInitialData] = React.useState([]);
	// const [searchValue, setSearchValue] = React.useState(null);
	const [searchVal, setSearchVal] = React.useState(searchValue || null);
	// const [alreadyPinned, setAlreadyPinned] = React.useState(false);
	const [siteId, setSiteId] = React.useState(selectedNode?.site_id ?? INITIAL_SITE_ID);
	// const [isDataFetched, setIsDataFetched] = React.useState(false);

	// const setSidebarPositionFixed = (status) => {
	// 	dispatch({ type: SIDE_BAR_TOPOLOGY_FLOATING, payload: status });
	// };

	const scrollToTop = () => {
		window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
	};
	// const prevGroupListRef = React.useRef(groupListBySite);


	useEffect(() => {
		if (tourStep === 1) {
			scrollToTop();
		}
	}, [tourStep]);

	// useEffect(() => {
	// 	if (triggerTourGuideModal && !alreadyPinned) {
	// 		setSidebarPositionFixed(true);
	// 	} else if (!triggerTourGuideModal && !alreadyPinned) {
	// 		setSidebarPositionFixed(false);
	// 	}
	// }, [triggerTourGuideModal, alreadyPinned]);

	useEffect(() => {
    if (!triggerSidebarRefresh) return;
    if (!group) {
      dispatch(listGroup()); // Dispatch the action to fetch group data
    }
    if (groupListBySite.length == 0) {
      dispatch(listGroupBySite(INITIAL_SITE_ID));
    }
  }, [triggerSidebarRefresh]);
  useEffect(() => {
    if (!siteId || (siteId==INITIAL_SITE_ID && groupListBySite.length != 0)) return;
    if (!group) {
      dispatch(listGroup()); // Dispatch the action to fetch group data
    }
    if (siteId) {
      dispatch(listGroupBySite(siteId));
    }
  }, [siteId]);

	const groupAddTrigger = useSelector(
		(state) => state.groupTrigger.groupAddTrigger
	);

	useEffect(() => {
		if (groupAddTrigger) {
			openAddGroupModal(true);
		} else if (groupAddTrigger === false) {
			openAddGroupModal(false);
		}
	}, [groupAddTrigger]);

	// useEffect(() => {
	// 	const topologyResponse = group;
	// 	const data = topologyResponse?.results || [];

	// 	data.forEach((item) => {
	// 		// make the parent id null for the root group
	// 		const parent = data.filter((i) => {
	// 			return i.site_id === item.parent_id;
	// 		});
	// 		if (parent.length === 0) {
	// 			item.parent_id = null;
	// 		}
	// 	});
	// 	const tree = buildTree(data);
	// 	setTreeData(tree);
	// 	setInitialData(tree);
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [group]);
	useEffect(() => {
		// setIsDataFetched(true);
		const topologyResponse = groupListBySite;
		const tree = buildTree(topologyResponse);
		// setTreeData(tree);

		// if (
		// 	(selectedNode && Object.keys(selectedNode).length === 0) ||
		// 	selectedNode === undefined
		// ) {
		// 	dispatch({
		// 		type: SELECTED_NODE_TOPOLOGY,
		// 		payload: tree[0],
		// 	});
		// 	if (tree[0] && Object.keys(tree[0]).length > 0) {
		// 		updatedBreadcrumbs(tree[0]);
		// 	}
		// }

		// setInitialData(tree);
		dispatch({ type: GROUP_BY_SITE_COPY, payload: tree });

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [groupListBySite, group]);

	useEffect(() => {
		if (!childData || !childData.parentId) return;

		const { parentId, children } = childData;

		const attachChildren = (nodes) =>
			nodes.map((node) => {
				if (node.site_id === parentId) {
					// Merge without duplicates
					const existingChildren = node.children || [];
					const mergedChildren = [
						...existingChildren,
						...(Array.isArray(children) 
						? children.filter(
							(c) => !existingChildren.some((ec) => ec.site_id === c.site_id)
						)
						: [])
					];

					return {
						...node,
						children: mergedChildren,
					};
				}
				if (node.children) {
					return {
						...node,
						children: attachChildren(node.children),
					};
				}
				return node;
			});

		const updatedTree = attachChildren(groupBySiteCopy);

		dispatch({
			type: GROUP_BY_SITE_COPY,
			payload: updatedTree,
		});
	}, [childData]);

	useEffect(() => {
		if (selectedNode) {
			onSelectedNode(selectedNode);
			onSelectedNodeTopology(selectedNode);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedNode]);

	// // Create a map of site IDs to site objects
	// const buildTree = (data, parentId = null) => {
	// 	const tree = [];
	// 	data.forEach((item) => {
	// 		// Check if the item belongs to the current parent
	// 		if (item.parent_id === parentId) {
	// 			// Recursively build the children of the current item
	// 			const children = buildTree(data, item.site_id);
	// 			// If children exist, assign them to the current item
	// 			if (children.length) {
	// 				item.children = children;
	// 			}
	// 			// Add the current item to the tree
	// 			tree.push(item);
	// 		}
	// 	});
	// 	// setFilteredTreeData(tree);

	// 	return tree;
	// };
	const buildTree = (sites, parentId = null) => {
		// Create a map to hold sites by their site_id for easy lookup
		const siteMap = new Map();
		sites.forEach((site) =>
			siteMap.set(site.site_id, {
				...site,
				name: site.site_name,
				id: site.site_id,
				children:
					site.children?.map((child) => ({
						...child,
						id: child.site_id,
						name: child.site_name,
					})) || [],
			})
		);

		// Create the tree structure
		const tree = [];

		sites.forEach((site) => {
			if (site.parent_id && siteMap.has(site.parent_id)) {
				// If the site has a parent, add it to the parent's children
				const parent = siteMap.get(site.parent_id);
				// Only add if not already present in parent's children
				if (!parent.children.some(child => child.site_id === site.site_id)) {
					parent.children.push(siteMap.get(site.site_id));
				}
			} else if (site.parent_id == INITIAL_SITE_ID || !site.parent_id) {
				// If the site has no parent, it's a top-level node
				tree.push(siteMap.get(site.site_id));
			}
		});

		// Helper function to recursively sort children by name
		const sortTree = (nodes) => {
			nodes.sort((a, b) => a.site_name.localeCompare(b.site_name));
			nodes.forEach((node) => {
				if (node.children && node.children.length > 0) {
					sortTree(node.children);
				}
			});
		};

		// Sort the top-level tree and its children
		sortTree(tree);

		return tree;
	};

	useEffect(() => {
		// if (searchValue == null) return;
		// Skip first render
		if (!didMountRef.current) {
			didMountRef.current = true;
			return;
		}
		if (searchValue && searchValue.length > 0) {
			dispatch(searchGroupBySite(searchValue, isExpandedView));
		} else if(searchValue === '') {
			dispatch({ type: GROUP_REQUEST_BY_SITE_GET });
			dispatch({ type: GROUP_RESPONSE_BY_SITE_GET_SUCCESS, payload: [] });
			dispatch(listGroupBySite(INITIAL_SITE_ID));
			dispatch({ type: SET_TOPOLOGY_SEARCH_VALUE, payload: null });
			dispatch({ type: SET_TOPOLOGY_EXPANDED_VIEW, payload: false });
		}
	}, [searchValue, isExpandedView]);

	useEffect(() => {
		if (selectedNode && Object.keys(selectedNode).length > 0) {
			updatedBreadcrumbs(selectedNode);
		}
	}, [selectedNode]);

	// /**
	//  * Filters an array of objects recursively by a query string.
	//  * @param {Array} arr - The array to filter.
	//  * @param {string} query - The query string to filter by.
	//  * @return {Array} - The filtered array.
	//  */
	// function filterBy(arr, query) {
	// 	return query
	// 		? arr.reduce((acc, item) => {
	// 				if (item.children?.length) {
	// 					const filtered = filterBy(item.children, query);
	// 					if (filtered.length)
	// 						return [...acc, { ...item, children: filtered }];
	// 				}

	// 				const { children, ...itemWithoutChildren } = item;
	// 				console.log(children);
	// 				return item.site_name
	// 					?.toLowerCase()
	// 					.includes(query.toLowerCase())
	// 					? [...acc, itemWithoutChildren]
	// 					: acc;
	// 		  }, [])
	// 		: arr;
	// }
	// const closeSideBarTopology = () => {
	// 	dispatch({ type: IS_SIDE_BAR_TOPOLOGY_OPEN, payload: false });
	// };
	const showSiteStatsSkeleton = groupDashStatsApiloading && selectedNode?.site_id;
	const TreeSkeleton = () => (
		<Box sx={{ pl: 2, pr: 2, pt: 1 }}>
			{[...Array(15)].map((_, i) => (
			<Box key={i} sx={{ display: 'flex', alignItems: 'center', height: 36, ml: i % 3 === 0 ? 0 : 3 }}>
				<Box sx={{ width: 16, height: 16, bgcolor: 'grey.300', borderRadius: 1, mr: 1 }} />
				<Box sx={{ width: '100%', height: 16, bgcolor: 'grey.300', borderRadius: 1 }} />
			</Box>
			))}
		</Box>
	);

	const filterTreeDataUsingSearchValue = (event) => {
		setSearchValue(event.target.value);
		// const filteredTreeData = filterBy(initialData, event.target.value);
		// setTreeData(filteredTreeData);
	};

	const setIsExpandedView = (val) => {
		dispatch({ type: SET_TOPOLOGY_EXPANDED_VIEW, payload: val });
	};

	const handleChangeVal = (event) =>{
		setSearchVal(event.target.value);
	}

	const openAddGroupModal = (val) => {
		dispatch({ type: OPEN_CLOSE_ADD_GROUP_MODAL, payload: val });
	};

	const updateBreadcrumbs = (payload) => ({
		type: UPDATE_BREADCRUMBS_STATE,
		payload: payload,
	});

	const selectNodeTopology = (selectedNode) => ({
		type: SELECTED_NODE_TOPOLOGY,
		payload: selectedNode,
	});

	const updatedBreadcrumbs = (node) => {
		const nestedSiteName = node?.nested_site_name;
		const selectedBreadcrumbs = nestedSiteName
			?.split('|')
			.reverse()
			.map((el) => {
				return {
					content: el,
					link: '/topology',
					isCurrent: true,
					type: 'group',
					group: getSpecificString(el, nestedSiteName),
					res: replacePipeWithAnd(el, nestedSiteName),
					// onClick: () => dispatch({ type: IS_SIDE_BAR_TOPOLOGY_OPEN, payload: false })
				};
			});
		if (selectedBreadcrumbs) {
			dispatch(
				updateBreadcrumbs(
					BREADCRUMBS_URL.TOPOLOGY.concat(selectedBreadcrumbs)
				)
			);
		}
	};
	const onSelectedNode = (selectedNode) => {
		try {
			if (selectedNode && selectedNode !== undefined) {
				dispatch(selectNodeTopology(selectedNode));
			}
			// console.log('selected node here', selectedNode);
		} catch (error) {
			console.error('Error selecting node:', error);
		}
	};
	const onSelectedNodeTopology = (selectedNode) => {
		try {
			onSelectedNode(selectedNode);
			updatedBreadcrumbs(selectedNode);
		} catch (error) {
			console.error('Error selecting node:', error);
		}
	};

	const { t } = useTranslation();
	const handleNodeExpand = (id) => {
		setSiteId(id);
	};

	const handleFocus = ()=>{
		setIsFocused(true);
	}
	const handleBlur = ()=>{
			if (inputRef.current.value.length === 0) {
				// setIsFocused(true);
				setIsFocused(false);
			}else if(inputRef.current.value.length > 0){
				setIsFocused(true);
			} else {
				setIsFocused(false);
			}
	}

	// const sortSites = (sitesArray) => {
	// 	return sitesArray.sort((a, b) => {
	// 		const nameA = a.site_name.toUpperCase();
	// 		const nameB = b.site_name.toUpperCase();

	// 		const isDigitA = /^\d/.test(nameA);
	// 		const isDigitB = /^\d/.test(nameB);

	// 		if (isDigitA && isDigitB) {
	// 			return nameA.localeCompare(nameB, undefined, { numeric: true });
	// 		} else if (isDigitA) {
	// 			return -1;
	// 		} else if (isDigitB) {
	// 			return 1;
	// 		} else {
	// 			return nameA.localeCompare(nameB);
	// 		}
	// 	});
	// };
	// console.log('treeData', treeData);

	const searchInput = document.getElementById('inpurtBaseSidebar');
	const [groupDashStatsApiProgress, setGroupDashStatsApiProgress] =
			useState(0);
	useEffect(() => {
		if (groupDashStatsApiloading || loadingBySite) {
			setGroupDashStatsApiProgress(50);

			const timeouts = [
				setTimeout(() => setGroupDashStatsApiProgress(75), 50),
				setTimeout(() => setGroupDashStatsApiProgress(100), 100),
			];

			return () => {
				timeouts.forEach(clearTimeout);
				setGroupDashStatsApiProgress(0);
			};
		}
		if (groupDashStatsApiloading === false || loadingBySite === false) {
			setGroupDashStatsApiProgress(0);
		}
	}, [groupDashStatsApiloading, loadingBySite]);

	// const isGroupLoading = !!(groupDashStatsApiloading || loadingBySite);
	
	const rawIsGroupLoading = !!(groupDashStatsApiloading || loadingBySite);
	const [isGroupLoading, setIsGroupLoading] = useState(rawIsGroupLoading);
	const _loadingTimeout = useRef(null);

	useEffect(() => {
		// When loading starts, it will ensure we show loading immediately and start a 5s timer.
		if (rawIsGroupLoading) {
			setIsGroupLoading(true);

			if (!_loadingTimeout.current === null || !_loadingTimeout.current) {
			_loadingTimeout.current = setTimeout(() => {
				// force isGroupLoading to false after 5 seconds of continuous loading
				setIsGroupLoading(false);
				_loadingTimeout.current = null;
			}, 5000);
			}
			return;
		}

		// If raw loading turned false before timeout, clear timer and set false
		if (_loadingTimeout.current) {
			clearTimeout(_loadingTimeout.current);
			_loadingTimeout.current = null;
		}
		setIsGroupLoading(false);

		// cleanup on unmount
		return () => {
			if (_loadingTimeout.current) {
			clearTimeout(_loadingTimeout.current);
			_loadingTimeout.current = null;
			}
		};
	}, [rawIsGroupLoading]);

	return (
		<div
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
			className={`fixed-sidebar ${tourStep === 1 ? 'highlight-tour-topology' : ''}`}
			style={{
				// borderRight: `solid 1px ${color.stroke.medium}`,
				// borderBottom: `solid 1px ${color.stroke.medium}`,
				backgroundColor: color.background.primary,
				// position: '-webkit-sticky',
				// position: 'sticky',
				width: `${sidebarWidth}px`,
				position:'fixed',
				marginTop: tourStep === 1 ? '0px' : '0px',
			}}
		>
			<div
				className="sidebar-header"
				style={{
					position: 'sticky',
					top: 65,
					zIndex: 10,
					backgroundColor: color.background.primary,
					padding: '10px',
					// marginLeft: '8px',
				}}
			>
				<div className="flex flex-between">
					<div className="flex">
						{/* <span
							className="groups"
							style={{
								fontSize: FontFace.font_size.input_text,
								color: color.text.primary,
							}}
						>
							<Label
								type={'primary'}
								fontSize={'input_text'}
								fontFamily={'Inter-Bold'}
								label={t('Sites')}
							/>
						</span> */}
						{/* {sideBarTopologyFloating ? (
						<PinIcon
							onClick={() => {
								setSidebarPositionFixed(
									!sideBarTopologyFloating
								);
								setAlreadyPinned(false);
							}}
							fill={color.icon.primary}
							height="12px"
							width="12px"
							style={{
								cursor: 'pointer',
								transform:
									sideBarTopologyFloating && 'rotate(315deg)',
								margin: '4px 1px 2px 8px',
							}}
						/>
					) : (
						<PinIcon
							onClick={() => {
								setSidebarPositionFixed(
									!sideBarTopologyFloating
								);
								setAlreadyPinned(true);
							}}
							height="12px"
							width="12px"
							style={{
								cursor: 'pointer',
								margin: '4px 1px 2px 8px',
							}}
						/>
					)} */}
					</div>

					{/* <div
						style={{
							marginRight: '0px',
							marginTop: '0px',
							marginLeft: '0px',
						}}
					>
						<Button
							id="step1Target"
							Icon={GroupSideBarCollapseIcon}
							iconSize={'24px'}
							align={'left'}
							// label={t('')}
							type={'tertiary_hover'}
							onClick={() => closeSideBarTopology()}
							width={'24px'}
							height={'24px'}
							style={{ padding: '0px', borderRadius: '10px' }}
						/>
					</div> */}
				</div>
				<div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
					<InputBase
						inputRef={inputRef}
						value={searchVal || ''}
						id='inpurtBaseSidebar'
						fontStyle={useTheme()}
						placeholder={t('Search')}
						className="search"
						onFocus={handleFocus}
						onBlur={handleBlur}
						onChange={handleChangeVal}
						onKeyDown={(e) => {
							if (e.key === 'Enter') {
								filterTreeDataUsingSearchValue(e);
							}
						}}
						sx={{
							'& input::placeholder': {
								width: '45px',
								height: '16px',
								fontSize: FontFace.font_size.x_small,
								fontFamily: 'Inter-Regular',
								lineHeight: '1.33',
								color: color.text.primary,
							},
							'&.Mui-focused': {
								borderBottomColor: `${color.input.line_active} !important`, // Change to your desired color
								borderBottomWidth: 2,
							},
							// fontSize: FontFace.font_size.x_small,
							lineHeight: '1.33',
							paddingBottom: '1px',
							paddingLeft: '8px',
							borderBottom: groupDashStatsApiProgress ? 'none' : `1px solid ${color.input.line}`,
							marginTop: '6px',
							fontFamily: 'Inter-Regular',
							fontSize: FontFace.font_size.x_small,
							width: `${Math.max(180, sidebarWidth - 40)}px`,
							// width: '100%',
						}}
						startAdornment={
							<InputAdornment position="start">
								<Box
									sx={{
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										height: '16px',
										width: '16px',
										marginRight:'-4px'
										// '&:hover': {
										// 	cursor: 'pointer',
										// 	backgroundColor:
										// 		color.background.tertiary,
										// },
									}}
									
								>
									{isFocused && (
									<SearchIconColored width="16px" height="16px" 
									// onClick={()=>filterTreeDataUsingSearchValue({
									// 		target: { value: inputRef.current.value },
									// 	})} 
										/>)}
									{!isFocused && (
									<GreySearch/>)}
								</Box>
								{/* <IconButton
								aria-label="search"
								style={{ marginTop: '6px' }}
							>
								<SearchIcon height="11.7px" width="11.7px" />
							</IconButton> */}
							</InputAdornment>
						}
						endAdornment={
							searchVal && (
							<InputAdornment position="end">
								<IconButton
									size="small"
									onClick={(e) => {
										filterTreeDataUsingSearchValue({
											target: { value: '' },
										});
										inputRef.current.value = '';
										if(searchVal){
											searchInput.focus();
										}
										// setIsFocused(false);
										setSearchVal(null);
									}}
								>
									<ClearOutlined fontSize="16px" />
								</IconButton>
								{/* <Box
									sx={{
										display: 'flex',
										marginRight: '5px',
										justifyContent: 'center',
										alignItems: 'center',
										height: '16px',
										width: '16px',
										'&:hover': {
											cursor: 'pointer',
											backgroundColor:
												color.background.tertiary,
										},
									}}
									
								>
									<SearchIcon width="16px" height="16px" onClick={()=>filterTreeDataUsingSearchValue({
											target: { value: inputRef.current.value },
										})} />
								</Box> */}
								{/* <IconButton
								aria-label="search"
								style={{ marginTop: '6px' }}
							>
								<SearchIcon height="11.7px" width="11.7px" />
							</IconButton> */}
							</InputAdornment>
							)
						}
					/>
					
				{ groupDashStatsApiProgress ?
					(<Box
						sx={{
							position: 'absolute',
							bottom: 12,
							left: 0,
							right: 0,
							// paddingTop: spacing.base_unit_4,
						}}
					>
						<Loader
							loaderType={
								'dividerProgressLine'
							}
							progressValue={
								groupDashStatsApiProgress
							}
						/>
					</Box>) : null 
				}
				</div>
				{canAddSite && ( 
				<div
					style={{
						justifyContent: 'space-between',
						display: 'flex',
						flexDirection: 'row',
					}}
				>
					{/* <Tooltip
						content={'Add a Site'}
						type="basic"
						direction="down"
						delay={300}
						style={{ width: '100px' }}
					> */}
						<Button
							startIcon={<ColouredAdd />}
								onClick={() => {
									dispatch({ type: 'SET_ADD_GROUP_SOURCE', payload: 'sidebar' });
									openAddGroupModal(true);
								}}
							color="inherit"
							sx={{
								color: color.text.hyperlink,
								fontSize: '12px',
								fontFamily: 'Inter-Medium',
								textTransform: 'none',
							}}
						>
							Add Site
						</Button>
					{/* </Tooltip> */}
					{/* <Button
						variant="text"
						color="inherit"
						sx={{
							textTransform: 'none',
							fontSize: '12px',
							fontFamily: 'Inter-Medium',
						}}
						onClick={() => setIsSidebarExpandAll((state) => !state)}
					>
						{isSidebarExpandAll ? 'Collapse All' : 'Expand All'}
					</Button> */}
					{searchVal && searchVal?.length > 0 && (<Grid
							style={{
								flexDirection: 'row',
								display: 'flex',
								alignItems: 'center',
							}}
							height={'48px'}
							paddingBottom={'16px'}
							paddingTop={'16px'}
						>
							<CustomCheckbox
								checked={isExpandedView}
								onChecked={(value) => {
									setIsExpandedView(value);
								}}
								name="expandedView"
							/>
							<Label
								label="Expanded view"
								style={{
									fontSize: '12px',
									fontFamily: 'Inter-Medium',
									textTransform: 'none',
									marginLeft: '8px'
								}}
							></Label>
						</Grid>)}
					</div>
				)}
			</div>
			{/* {loadingBySite && groupBySiteCopy.length == 0 && (
				<div
					style={{
						position: 'absolute', // Position it absolutely within the sidebar
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
						backdropFilter: 'blur(5px)', // Blur effect
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						zIndex: 1000, // Ensure it's above other content
					}}
				>
					<Loader />
				</div>
			)} */}
			{loadingBySite  && groupBySiteCopy.length === 0 ? (
				<div
					style={{
						display: 'flex',
						marginTop: '24px',
						marginBottom: '24px',
						justifyContent: 'center',
					}}
				>
					<Loader />
				</div>
			) : groupBySiteCopy.length === 0 ? (
				 <Box
					sx={{
					display: 'flex',
					marginTop: '24px',
					marginBottom: '24px',
					justifyContent: 'center',
					alignItems: 'center',
					color: color.text.secondary,
					fontFamily: 'Inter-Regular',
					fontSize: FontFace.font_size.x_small,
					}}
				>
					No site present
				</Box>
				): showSiteStatsSkeleton ? (
					<TreeSkeleton />) : (
				<div
					style={{
						position: 'absolute',
						// marginLeft: '8px',
					}}
				>
					<TopologyLazyTree
						treeData={groupBySiteCopy}
						searchValue={searchValue}
						selectedGrp={selectedNode}
						onNodeSelect={
							(selectedNode)=>{
								if (selectedNode && selectedNode?.site_id !== undefined){
									onTopologySelected && onTopologySelected(selectedNode);
								}
								if (selectedNode?.showChildSites && selectedNode?.siteId) {
									dispatch(listGroupChildBySite(selectedNode?.siteId));
								} else {
									onSelectedNodeTopology(selectedNode);
								}
							}
						}
						onExpand={handleNodeExpand}
						isLoading={isGroupLoading}
						width={sidebarWidth - 18}
					/>
					</div>
			)}	
		</div>
	);
}
TopologySidebar.propTypes = {
	triggerSidebarRefresh: PropTypes.bool,
	setIsHovered: PropTypes.func,
	onTopologySelected: PropTypes.func,
	sidebarWidth: PropTypes.number,
};
